export default __webpack_public_path__ + "static/media/Niramit-ExtraLightItalic.de0d2ac2.ttf";